export const en = {
  noConversation: {
    welcome: 'Welcome to Your Inbox',
    selectConversation:
      'Select a conversation from the left or click the button below to start a new one.',
    startNew: 'Start New Conversation',
  },
  conversationList: {
    newConversation: 'New Conversation',
    search: 'Search',
    conversation: 'conversation',
    conversations: 'conversations',
  },
  participantPopover: {
    internal: 'Internal',
    external: 'External',
    searchContact: 'Search contact',
    noContactsFound: 'No contacts found',
  },
  participants: {
    employees: 'Employees',
    addParticipant: 'Add Participant',
    external: 'External',
    you: '(you)',
  },
  conversationCard: {
    untitledConversation: 'Untitled Conversation',
    loadingParticipants: 'Loading participants...',
    noMessagesYet: 'No messages yet',
  },
};

export type ChatTranslationsType = typeof en;
